import styled from 'styled-components'

export const Label = styled.span`
	display: flex;
	width: 100%;
	align-items: center;
	column-gap: 6px;
	font-size: 15px;
	line-height: 21px;

	> svg {
		flex-shrink: 0;
		height: 18px;
		width: 18px;
	}
`
